import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getGroupApplicationAvailableColumns } from './api';

export const path = '/group-application/list';

const PageGroupApplications: React.FC = (props) => {
  const GroupApplications = Loadable.Map({
    loader: {
      page: () => import('./page'),
      columns: getGroupApplicationAvailableColumns,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <GroupApplications {...props} />;
};

export default PageGroupApplications;
